import { useState } from 'react'
import { AccountMenuAvatarTrigger } from '@/components/account/account-menu-avatar-trigger'
import { AccountMenuIdentityHeader } from '@/components/account/account-menu-identity-header'
import { AccountMenuItems } from '@/components/account/account-menu-items'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useAuth } from '@/hooks/use-auth'
import { useAccountMenuIdentity } from '@/hooks/use-account-menu-identity'
import { useFocusStore } from '@/hooks/use-focus-store'
import { getFocusRoute } from '@/utils/focus-routes'

type MarketingAuthMenuProps = {
  appHref?: string
  appLabel?: string
  className?: string
}

/** Compact avatar account menu for marketing / public share headers. */
export function MarketingAuthMenu({
  appHref,
  appLabel = 'Go to app',
  className,
}: MarketingAuthMenuProps) {
  const { logout } = useAuth()
  const { personName, email, primaryLabel, avatarUrl, avatarColorSeed } = useAccountMenuIdentity()
  const { focus } = useFocusStore()
  const [menuOpen, setMenuOpen] = useState(false)

  const resolvedAppHref = appHref ?? getFocusRoute(focus?.current_focus ?? null)

  return (
    <DropdownMenu open={menuOpen} onOpenChange={setMenuOpen}>
      <DropdownMenuTrigger asChild>
        <AccountMenuAvatarTrigger
          src={avatarUrl}
          colorSeed={avatarColorSeed}
          alt={primaryLabel}
          className={className}
          aria-label={`Account menu for ${primaryLabel}`}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="bottom" className="w-[240px]">
        <AccountMenuIdentityHeader personName={personName} email={email} />
        <AccountMenuItems
          logout={logout}
          onClose={() => setMenuOpen(false)}
          showGoToApp
          goToAppHref={resolvedAppHref}
          goToAppLabel={appLabel}
          showSettings
          showLogout
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
